import { createReducer } from '@reduxjs/toolkit';
import type { BsiTask, IBsiPopupResponses } from '../../api/domain';
import {
    fetchBsiCasesSuccess,
    fetchPopupResponsesSuccess,
    markPopupNotificationForDeletion,
    removePopupNotifications,
    selectPopupNotification,
} from './process-engine-api-actions';

interface IProcessEngineApiState {
    bsiCases: BsiTask[];
    bsiPopupResponses: Record<string, IBsiPopupResponses>;
    bsiPopupResponsesMarkedForDeletion: Array<{ kdLnr: string; popupId: string }>;
    bsiPopupSelected?: { kdLnr: string; popupId: string };
}
export type { IProcessEngineApiState };

export const initialState: IProcessEngineApiState = {
    bsiCases: [],
    bsiPopupResponses: {},
    bsiPopupResponsesMarkedForDeletion: [],
    bsiPopupSelected: undefined,
};

export const processEngineApiReducer = createReducer(initialState, (builder) => {
    builder.addCase(fetchBsiCasesSuccess, (state, { payload: bsiCases }) => {
        state.bsiCases = bsiCases;
    });
    builder.addCase(fetchPopupResponsesSuccess, (state, { payload }) => {
        state.bsiPopupResponses = { ...state.bsiPopupResponses, [payload.kdLnr]: payload.popupResponses };
    });
    builder.addCase(selectPopupNotification, (state, { payload }) => {
        state.bsiPopupSelected = { kdLnr: payload.kdLnr, popupId: payload.popupId };
    });
    builder.addCase(markPopupNotificationForDeletion, (state, { payload }) => {
        state.bsiPopupResponsesMarkedForDeletion.push(payload);
    });
    builder.addCase(removePopupNotifications, (state) => {
        let bsiPopupResponsesCopy = { ...state.bsiPopupResponses };
        state.bsiPopupResponsesMarkedForDeletion.forEach((marked) => {
            const filtered = bsiPopupResponsesCopy[marked.kdLnr]?.popupResponses?.filter((it) => marked.popupId !== it.id);
            if (filtered?.length >= 1) {
                bsiPopupResponsesCopy = {
                    ...bsiPopupResponsesCopy,
                    [marked.kdLnr]: { popupResponses: filtered },
                };
            } else if (filtered) {
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete bsiPopupResponsesCopy[marked.kdLnr];
            }
        });
        state.bsiPopupResponses = bsiPopupResponsesCopy;
        state.bsiPopupResponsesMarkedForDeletion = [];
        state.bsiPopupSelected = undefined;
    });
});
